import { useFormikContext } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  getFundingCurrencySelectField,
  isVisibleFundingFormField,
} from '@pages/Traders-Room/shared/hooks/useFundingCurrencySelector'

import type { WalletDepositFormValues } from '@model/WalletDepositFormValues'

import { FormFieldsFactory } from '@global/formField/formFieldsFactory/FormFieldsFactory'

export const WalletFormFieldsFactory: React.FC = () => {
  const { values } = useFormikContext<WalletDepositFormValues>()
  const { t } = useTranslation()
  const depositCurrencyFieldName = getFundingCurrencySelectField(
    values.paymentProvider.parameters.fields
  )?.name

  const resolvedFields = values.paymentProvider.parameters.fields
    .filter((field) => isVisibleFundingFormField(field, depositCurrencyFieldName))
    .map((field) =>
      field.name.endsWith('name_of_account') ? { ...field, label: t('Cardholder Name') } : field
    )

  return <FormFieldsFactory fields={resolvedFields} />
}
